// extracted by mini-css-extract-plugin
export default {"templateContainer":"CreateTemplate_templateContainer__FDwby"};